export default "__VITE_ASSET__DMDPV6e4__"